import { xmlRpcEndpoint } from '@/services/Authentication';
import {xmlRpcClient} from './client';

// Upload contact list
const toggleInstance = (status: boolean) => {
  const verbCreate = status ? 'instancename.enableallinstances' : 'instancename.disableallinstances';
  const paramsCreate = [{Params: ''}];
  return client(verbCreate, paramsCreate);
};

const client = async (verb: any, params: any) => {
  const retData = await xmlRpcClient(xmlRpcEndpoint(), verb, params);
  return retData;
};

export { toggleInstance };
